import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';

const Routing = () => {
    const router=createBrowserRouter([{
        path:"/",
        element:<HomePage />
    },
    {
        path:"/category/:category_name",
        element:<CategoryPage />
    },
    {
        path:"/category/video/play",
        element:<CategoryVideoPlay />
    },
    {
        path:"*",
        element:<Navigate to={"/"} />
    }
])
  
    return (
    <RouterProvider router={
        router
    } />
  )
}

export default Routing